import axios from 'axios';

App.Recaptcha = {

    opt_widget_id: 0,

    recaptchaSelector: '.js--recaptcha',

    init: function(){

        document.querySelectorAll(this.recaptchaSelector+':not(._recaptcha-init)').forEach(el => {

            const widgetId = grecaptcha.render(el, {
                sitekey: G_RECAPTCHA_SITE_KEY,
                callback: function(token) { // Добавим callback
                    const form = el.closest('form');
                    App.Recaptcha.sendFormData(form); // Вызываем функцию отправки формы
                },
                size: 'invisible',
                'error-callback': function() {
                    console.error('reCAPTCHA error callback called!');
                }
            });

            // Сохраняем ID виджета в атрибуте data-widget-id
            el.dataset.widgetId = widgetId;

            el.classList.add('_recaptcha-init');

        });

    },

    execute: function (element) {
        console.log('execute');
        grecaptcha.execute(element);
    },

    sendFormData: function (form){
        console.log('callback');
        const formData = new FormData(form);

        axios.post(form.action, formData)
            .then((response) => {

                if(App.AjaxPreloader){
                    App.AjaxPreloader.stop();
                }

                form.classList.remove('_disabled');

                const data = response.data;

                form.querySelectorAll('.form-item').forEach((formItem) => {
                    formItem.classList.remove('_error');
                });

                switch (data.STATUS) {
                    case 'ERROR':

                        for (let key in data.ERRORS) {

                            let input = form.querySelector('[name="' + key + '"]');
                            if (!input) input = form.querySelector('[name="' + key + '[]"]');
                            if (input) {
                                const inputContainer = input.closest('.form-item'),
                                    errorText = inputContainer.querySelector('.form-item__error');
                                if (errorText) errorText.innerHTML = data.ERRORS[key];
                                inputContainer.classList.add('_error');
                            } else if (key === 'other') {
                                const errorText = form.querySelector('.js--form-other-error');
                                if (errorText) {
                                    errorText.innerHTML = data.ERRORS[key];
                                    errorText.classList.add('_error');
                                }
                            }

                        }

                        break;
                    case 'OK':

                        form.querySelectorAll('[type=text], [type=tel], [type=email], textarea').forEach((input) => {
                            input.value = '';
                        });

                        App.Popup.openPopupSuccess({
                            title: data.SUCCESS_TITLE,
                            text: data.SUCCESS_TEXT
                        });

                        App.Seo.send('formSend', data.WEBFORM_SID, data.SEO_E_LABEL, data.SEO_E_PARAMS);

                        break;
                }

                grecaptcha.reset()

            })
            .catch((error) => {
                App.AjaxPreloader.stop();
                form.classList.remove('_disabled');
                console.log(error);
            });


    },

    update: function(el){

        if (!el) return;
        const ID = el.dataset.optWidgetId;
        if (!ID) return;
        grecaptcha.reset(Number(ID));

    }
}